import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ExportType, TableExportDirective } from '../table-export/table-export.directive';

@Component({
    selector: 'app-global-export-csv',
    templateUrl: './global-export-csv.component.html',
    styleUrls: ['./global-export-csv.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class GlobalExportCsvComponent implements OnInit {
    @Input() componentName: string;
    @Input() exporter: TableExportDirective;

    @Input() type = 'button';

    ngOnInit(): void {
        if (!this.type) {
            this.type = 'button';
        }
    }

    exportCsv() {
        if (!this.exporter) {
            return;
        }

        this.exporter.exportTable(ExportType.CSV, {
            fileName: this.componentName + Date.now(),
            Props: {
                Author: 'Resumo',
            },
        });
    }
}
